import { TableCell, TableHead } from "@mui/material";
import { styled } from "@mui/material/styles";

export const StyledTableHead = styled(TableHead)(({ theme }) => ({
  backgroundColor: "rgb(11, 48, 149)",
}));

export const StyledHeaderCell = styled(TableCell)(({ theme }) => ({
  color: theme.palette.common.white,
  fontWeight: "bold",
  borderBottom: "none",
}));

export const StyledTableCell = styled(TableCell)(({ theme }) => ({
  borderBottom: "1px solid #e0e0e0",
}));

export const StyledEntityCell = styled(StyledTableCell)(({ theme }) => ({
  backgroundColor: "#ef4c3a ",
  color: theme.palette.common.white,
}));
export const StyledTitle = styled("div")(({ theme }) => ({
  display: "flex",
  alignItems: "center",
  marginBottom: 16,
}));

export const ButtonsContainer = styled("div")(({ theme }) => ({
  color: theme.palette.common.white,
  display: "flex",
  justifyContent: "flex-end",
}));

export const StyledDateContainer = styled("div")(({ theme }) => ({
  display: "flex",
  alignItems: "center",
  justifyContent: "flex-end",
  width: "100%",
  gap: 16,
}));

export const StyledFilterContainer = styled("div")(({ theme }) => ({
  display: "flex",
  alignItems: "flex-end",
  gap: theme.spacing(2),
  width: "100%",
}));

export const StyledClientFieldContainer = styled("div")(({ theme }) => ({
  display: "flex",
  alignItems: "center",
  justifyContent: "center",
  gap: 16,
  flexWrap: "wrap",
  "& button": {
    height: 40,
    bottom: 4,
  },
  "& > *": {
    flexShrink: 0,
  },

  [theme.breakpoints.up("md")]: {
    flexDirection: "row",
    "& .MuiTextField-root": {
      minWidth: 200,
    },
  },

  [theme.breakpoints.down("md")]: {
    flexDirection: "column",
    alignItems: "stretch",
    "& .MuiTextField-root": {
      margin: 0,
      width: "100%",
    },
    "& button": {
      width: "100%",
    },
  },
}));
